exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FilterMultiSelect {\n    top: 22px;\n    height: 24px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n}\n\n.FilterMultiSelect-item > div > div {\n    padding-left: 32px!important;\n    padding-right: 8px!important;\n}\n\n.FilterMultiSelect-item svg {\n    left: 5px!important;\n    top: 0!important;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/datatable/FilterMultiSelect.css
// module id = 1089
// module chunks = 0